/**
 * The Lattice mark: five points joined into two rhombi, the smallest piece of a lattice. Drawn in
 * `currentColor` so it takes the colour of whatever text it sits beside, in either theme.
 */
export function Mark({ size = 24 }: { readonly size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M12 3 L20 12 L12 21 L4 12 Z M4 12 L20 12"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="3" r="2" fill="currentColor" />
      <circle cx="20" cy="12" r="2" fill="currentColor" />
      <circle cx="12" cy="21" r="2" fill="currentColor" />
      <circle cx="4" cy="12" r="2" fill="currentColor" />
      <circle cx="12" cy="12" r="2.6" fill="currentColor" />
    </svg>
  );
}
